import { Checkbox, Dropdown } from 'antd';

import { SettingOutlined } from '@ant-design/icons';

interface ColumnOption {
  id: string;
  label: string;
  checked: boolean;
}

interface ColumnVisibilityMenuProps {
  columnOptions: ColumnOption[];
  onToggleColumn: (columnId: string) => void;
}

const ColumnVisibilityMenu = ({ columnOptions, onToggleColumn }: ColumnVisibilityMenuProps) => {
  const items = [
    {
      key: 'columnVisibility',
      label: (
        <div className="p-2 min-w-[200px]">
          <div className="font-semibold mb-2">Column Visibility</div>
          {columnOptions.map((option) => (
            <div key={option.id} className="flex items-center mt-2">
              <Checkbox checked={option.checked} onChange={() => onToggleColumn(option.id)} />
              <span className="ml-2 capitalize">{option.label || option.id}</span>
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <button className="p-2 text-neutral-50 hover:text-primary-60 hover:bg-gray-100 rounded-md">
        <SettingOutlined className="text-lg" />
      </button>
    </Dropdown>
  );
};

export default ColumnVisibilityMenu;
